import { render, staticRenderFns } from "./SingleFileUpload.vue?vue&type=template&id=1f427a22&scoped=true&"
import script from "./SingleFileUpload.vue?vue&type=script&lang=js&"
export * from "./SingleFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f427a22",
  null
  
)

export default component.exports